import { render, staticRenderFns } from "./r-ad-unit-page.vue?vue&type=template&id=4b42e927"
import script from "./r-ad-unit-page.vue?vue&type=script&lang=js"
export * from "./r-ad-unit-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b42e927')) {
      api.createRecord('4b42e927', component.options)
    } else {
      api.reload('4b42e927', component.options)
    }
    module.hot.accept("./r-ad-unit-page.vue?vue&type=template&id=4b42e927", function () {
      api.rerender('4b42e927', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/ad-settings/unit/r-ad-unit-page.vue"
export default component.exports